import { useRef, useState } from "react";
import { useFrame } from "@react-three/fiber";
import { Center, Text3D } from "@react-three/drei";
import Star from "../meshes/Stars/Star";
import MeshColors from "./MeshColors";
import { getSocket } from "../socket.js";

const socket = getSocket();
import { useParams } from "wouter";
import { useAtomValue } from "jotai";
import { clientAtom, hostAtom, languageAtom } from "../GlobalState";
import translations from "../dictionaries/translations.js";
import { trackEvent } from '../api';

export default function PauseGame({ position, scale=1 }) {
  const [hover, setHover] = useState(false);
  const language = useAtomValue(languageAtom)
  const fontUrl = language === 'korean' ? "/fonts/Maplestory_Bold.json" : language === 'chinese' ? "/fonts/Xiao Xiangjiao font_Regular.json" : "/fonts/Luckiest Guy_Regular.json";

  const params = useParams();
  const client = useAtomValue(clientAtom)
  const host = useAtomValue(hostAtom)
  const isHost = client._id === host._id

  const borderMesh0Ref = useRef();
  const borderMesh1Ref = useRef();
  const borderMesh2Ref = useRef();
  const borderMesh3Ref = useRef();
  const borderMesh4Ref = useRef();
  const borderMesh5Ref = useRef();
  const borderMesh6Ref = useRef();
  const borderMeshRefs = [
    borderMesh0Ref,
    borderMesh1Ref,
    borderMesh2Ref,
    borderMesh3Ref,
    borderMesh4Ref,
    borderMesh5Ref,
    borderMesh6Ref
  ]
  const width = 2.7
  const height = 2
  useFrame((state, delta) => {
    for (let i = 0; i < borderMeshRefs.length; i++) {      
      if (borderMeshRefs[i].current) {
        borderMeshRefs[i].current.position.x = Math.cos(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * width
        borderMeshRefs[i].current.position.y = 0.1
        borderMeshRefs[i].current.position.z = Math.sin(state.clock.elapsedTime / 2 + 2 * Math.PI/borderMeshRefs.length * i) * height
      }
    }
  })

  function handlePointerEnter(e) {
    e.stopPropagation()
    setHover(true)
  }
  
  function handlePointerLeave(e) {
    e.stopPropagation()
    setHover(false)
  }
  
  function handlePointerUp(e) {
    e.stopPropagation()
    if (isHost) {    
      socket.emit('pauseGame', ({ roomId: params.id, clientId: client._id, flag: false}))
      trackEvent({ surface: 'game', action: 'resume_game', category: 'ui' })
    }
  }

  return <group position={position} scale={scale}>
    <mesh
      castShadow
      receiveShadow
      scale={[2.6, 0.055, 2]}
      onPointerEnter={e => handlePointerEnter(e)}
      onPointerLeave={e => handlePointerLeave(e)}
      onPointerUp={e => handlePointerUp(e)}
    >
      <cylinderGeometry args={[1, 1, 1, 64]}/>
      <meshStandardMaterial color='black' opacity={0.8} transparent/>
    </mesh>
    <group name='content'>
      <Center position={ isHost ? [0, 0.05, -0.5] : [0, 1, 0.3] } key={Math.random()}>
        <Text3D
          font={fontUrl}
          rotation={[Math.PI/2, Math.PI, Math.PI]}
          size={0.7}
          height={0.01}
          lineHeight={0.8}
        >
          {translations.alerts.paused[language]}
          <meshStandardMaterial color='limegreen'/>
        </Text3D>
      </Center>
      {/* unpause if host */}
      { isHost && <Center name='unpause-button' position={[0.1, 0.2, 0.8]}>
        <mesh name='unpause-button-outer-box'>
          <boxGeometry args={[2.85, 0.01, 0.95]}/>
          <meshStandardMaterial color={ hover ? 'green' : 'yellow' }/>
        </mesh>
        <mesh name='unpause-button-inner-box'>
          <boxGeometry args={[2.8, 0.02, 0.9]}/>
          <meshStandardMaterial color={MeshColors.spaceDark}/>
        </mesh>
        <Center key={Math.random()} position={[0, 0.2, 0.05]}>
          <Text3D
            font={fontUrl}
            rotation={[-Math.PI/2, 0, 0]}
            size={0.4}
            height={0.01}
            lineHeight={0.8}
          >
            {translations.alerts.unpause[language]}
            <meshStandardMaterial color={ hover ? 'green' : 'yellow' }/>
          </Text3D>
        </Center>
      </Center>}
    </group>
    <group ref={borderMesh0Ref}>
      <Star 
        scale={0.2}
        color='limegreen'
      />
    </group>
    <group ref={borderMesh1Ref}>
      <Star 
        scale={0.2}
        color='limegreen'
      />
    </group>
    <group ref={borderMesh2Ref}>
      <Star 
        scale={0.2}
        color='limegreen'
      />
    </group>
    <group ref={borderMesh3Ref}>
      <Star 
        scale={0.2}
        color='limegreen'
      />
    </group>
    <group ref={borderMesh4Ref}>
      <Star 
        scale={0.2}
        color='limegreen'
      />
    </group>
    <group ref={borderMesh5Ref}>
      <Star 
        scale={0.2}
        color='limegreen'
      />
    </group>
    <group ref={borderMesh6Ref}>
      <Star 
        scale={0.2}
        color='limegreen'
      />
    </group>
  </group>
}